<template>
<div :id="product.Id"  class="product-box wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s">
    <div class="img-top">
        <router-link :to="{ name: 'view-product', params: { id: product.Id, name: deflate(product.Title) } }" class="img-container">
            <div class="content">
                <img :src="product.PrimaryImage.Url">
            </div>
        </router-link>
    </div>
    <router-link :to="{ name: 'view-product', params: { id: product.Id, name: deflate(product.Title) } }" class="product-name">
        {{product.Title}}
    </router-link>
    <router-link :to="{ name: 'view-product', params: { id: product.Id, name: deflate(product.Title) } }" class="more-info">
        <div class="read-more">
            <span class="fas fa-arrow-left read-more-icon"></span>
            <span>اقرأ المزيد</span>
        </div>
    </router-link>
</div>
</template>
<script>
export default {
    name: 'Product2',
    
    props: ['product'],
}
</script>
<style lang="scss">
  @import "src/assets/sass/shared.scss";
    .product-box{
        display:block;
        background-color:#fff;
        margin-bottom:15px;
        margin-top:15px;
        width:100%;
         border: 1px solid #ddd;
        @include prefixer(box-shadow,-1px 0px 10px -4px rgba(0,0,0,0.2),("moz","ms","webkit","o"));
         text-align: center;
        transition-duration: 0.4s;
        top: 0;
        position: relative;
        @include prefixer(transform,all 0.3s ease-out,("moz","ms","o","webkit"));

        &:hover{
             @include prefixer(box-shadow,0 3px 6px rgba(0, 0, 0, .2),("moz","webkit","ms","o"));
             top: -10px;
            .read-more{
               
                span{
                    color: rgba(37, 37, 37, 0.87) !important;
                }
                .read-more-icon{
                    @include prefixer(transform , translateX(-10px),("moz","ms","webkit","o"));
                    color: rgba(37, 37, 37, 0.87);
                }
            }
        }

        .img-container{
            width:100%;
            display:block;
            @include aspect-ratio(4,3);

            .content{
                overflow: hidden;
            }
             img{
                 width:100%;
                 height:100%;
                 object-fit:cover;
             }
        }
        .product-name{
            color:$secondary-color;
            padding:0px 4px 10px;
            @include prefixer(transition,color 0.4s ease-out,("moz","ms","o","webkit"));
            @include multiline-ellipses(15px,1.2,2);
            margin-top:38px;
           
        }
        .more-info{
            margin-bottom:38px;
            margin-top:2px; 
            position: relative;
            display:inline-block;
            .read-more{
                overflow: hidden;
                 display: flex;
                flex-direction: row-reverse;
                direction:$dir;
                align-items: center;
                 span{
                font-size:12px;
                color:$main-color;
                @include margin-right(10px,$dir);
                @include float-right($dir);
               @include prefixer(transition,all 0.6s , ("moz","ms","webkit","o"));
                
                &.fa{
                    @include prefixer(transition,all 0.6s , ("moz","ms","webkit","o"));
                  
                }
            }
            }
           
            
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/products/productv2.vue